export default __webpack_public_path__ + "static/media/navbar-sender-dark.7a5159a6.svg";